// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Li-Yc","toggleWrap":"styles_toggleWrap__3XybY","content":"styles_content__2DV-0","selectAreaCode":"styles_selectAreaCode__3PPWE"};